import { render, staticRenderFns } from "./categoryChartPie.vue?vue&type=template&id=722a30bc"
import script from "./categoryChartPie.vue?vue&type=script&lang=js"
export * from "./categoryChartPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports